import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-123">
      {/* Video Background — Mediterranean sunset */}
      <div className="absolute inset-0 w-full h-full" data-id="element-124">
        <video autoPlay loop muted playsInline className="object-cover w-full h-full scale-[1.02]" data-id="element-125">
          <source src="https://videos.pexels.com/video-files/1918465/1918465-uhd_2560_1440_24fps.mp4" type="video/mp4" data-id="element-126" />
        </video>
        {/* Warm sunset overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-navy/30 via-transparent to-navy/60" data-id="element-127" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1A2744]/70 via-[#2C1810]/20 to-transparent" data-id="element-128" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 max-w-5xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: [0.4, 0, 0.2, 1]
      }} className="mb-8" data-id="element-130">
          <div className="flex items-center justify-center gap-5 mb-8" data-id="element-131">
            <div className="h-px w-16 bg-gradient-to-r from-transparent to-sand/60" data-id="element-132"></div>
            <span className="text-sand-light text-[11px] font-sans font-medium tracking-[0.4em] uppercase" data-id="element-133">
              Restaurant
            </span>
            <div className="h-px w-16 bg-gradient-to-l from-transparent to-sand/60" data-id="element-134"></div>
          </div>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-[5.5rem] text-white font-medium tracking-tight leading-[0.95]" data-id="element-135">
            El Astillero
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: [0.4, 0, 0.2, 1]
      }} className="text-lg md:text-xl text-white/75 font-light tracking-wide mb-16 max-w-lg font-sans" data-id="element-136">
          {t.hero.tagline}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1,
        ease: [0.4, 0, 0.2, 1]
      }} className="flex flex-col sm:flex-row gap-5" data-id="element-137">
          <Link to="/reservations" className="px-11 py-4 bg-sand hover:bg-sand-dark text-navy font-medium text-[11px] tracking-[0.2em] uppercase transition-all duration-700 ease-elegant hover:shadow-warm hover:scale-[1.02]" data-id="element-138">
            {t.hero.book}
          </Link>
          <Link to="/menu" className="px-11 py-4 border border-white/30 text-white hover:bg-white/10 hover:border-white/60 font-medium text-[11px] tracking-[0.2em] uppercase transition-all duration-700 ease-elegant backdrop-blur-sm" data-id="element-139">
            {t.hero.menu}
          </Link>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-16 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-3" data-id="element-140">
        <span className="text-white/40 text-[9px] uppercase tracking-[0.3em] font-medium" data-id="element-141">
          Scroll
        </span>
        <motion.div animate={{
        y: [0, 6, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="w-[1px] h-8 bg-gradient-to-b from-white/40 to-transparent" data-id="element-142" />
      </motion.div>

      {/* Subtle dark bottom edge for clean transition */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-navy/40 via-navy/15 to-transparent z-10" data-id="element-143" />
    </section>;
}